// @ts-check
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { ListItemSecondaryAction } from '@material-ui/core';

import IconButton from '@material-ui/core/IconButton/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: 'inline'
  }
}));

export function AlignItemsList({ users }) {
  const classes = useStyles();
  const history = useHistory();

  const n = users.length - 1;
  const renderUsers = users.map((user, index) => {
    return (
      <div key={index}>
        <ListItem
          alignItems="flex-start"
          button
          onClick={() => history.push(`/users/${user.id}/view`)}
        >
          <ListItemAvatar>
            <Avatar alt={user.name} src={user.image || '/static/images/avatar/1.jpg'} />
          </ListItemAvatar>
          <ListItemText
            primary={user.name}
            secondary={<React.Fragment>{user.email}</React.Fragment>}
          />

          <ListItemSecondaryAction>
            <IconButton
              edge="end"
              aria-label="comments"
              onClick={() => history.push(`/users/${user.id}/view`)}
            >
              <VisibilityIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
        {index !== n && <Divider variant="inset" component="li" />}
      </div>
    );
  });

  return <List className={classes.root}>{renderUsers}</List>;
}
